var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BasePromo",class:_vm.customClass},[_c('div',[_c('img',{attrs:{"src":_vm.promoImage,"alt":"Promotion 6 + 1"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }